"use client";

import { useEffect } from "react";
import type { PressLang } from "@/lib/press/kit";

/** Keeps <html lang> aligned with the press kit, without touching the site language preference. */
export function PressDocumentLang({ lang }: { lang: PressLang }) {
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return null;
}
